import { unmask } from '@packages/gql/src/betterMasking';
import type { DimensionFragmentFragmentDoc } from '@packages/gql/generated/shopping/DimensionFragmentFragmentDoc';
import type { DimensionsForTracking } from '../getAddToBasketColorString/getAddToBasketColorString';

export function getAddToBasketVariantString(dimensions: DimensionsForTracking) {
  const variant: string[] = [];
  dimensions
    .map((dimension) => unmask<typeof DimensionFragmentFragmentDoc>(dimension))
    .forEach(({ values }) => {
      values.forEach(({ isSelected, displayText }) => {
        if (isSelected === true && displayText) {
          variant.push(displayText);
        }
      });
    });

  return variant.join(', ');
}
